var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 607,
    viewBox: "0 0 607 607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0684 161.468L308.392 27.7003L544.901 169.809L540.086 445.686L298.762 579.454L62.2529 437.345L67.0684 161.468Z",
    stroke: "#FFE713",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9154 147.994L322.985 26.0269L553.647 181.61L534.239 459.161L284.169 581.128L53.5072 425.545L72.9154 147.994Z",
    stroke: "#FFBD13",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8933 185.749L279.278 25.8323L531.961 143.661L556.261 421.405L327.877 581.322L75.1928 463.493L50.8933 185.749Z",
    stroke: "#FF7F38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1882 177.526L289.046 26.3066L536.435 152.358L550.966 429.628L318.108 580.848L70.7193 454.797L56.1882 177.526Z",
    stroke: "url(#paint0_linear_86_308)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_308",
    x1: 63.2254,
    y1: 324.12,
    x2: 544.956,
    y2: 324.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8139"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBig);
export default __webpack_public_path__ + "static/media/circle-big.97b5d0c3d6672c5079cde5527d8f51a9.svg";
export { ForwardRef as ReactComponent };